<script>
import component from './base.vue';

export default component.extend({
  computed: {
    disableCustomer: () => false,
  },
});
</script>
